import {
    Card,
    Input,
    Button,
    Typography,
} from "@material-tailwind/react";
import { useState } from "react";
import { toast } from "react-toastify";
import { useAtom } from "jotai";
import { userAtom } from "../store";
import UserAPI from '../api/user';
import { useNavigate } from "react-router-dom";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [, setUserAuth] = useAtom(userAtom);
    const navigate = useNavigate();

    const login = async () => {
        if (!email || !password) {
            toast.error("Please enter email and password");
            return;
        }

        const userData = await UserAPI.login(email, password);
        if (userData) {
            setUserAuth(userData);
            navigate("/");
        }
    }

    return (
        <div className="flex items-center justify-center h-[100vh] px-6">
            <Card className="px-8 py-10 w-fit">
                <Typography className="text-2xl font-bold">Sign In</Typography>
                <Typography className="mt-1">
                    Welcome to the Pharmacy Wiki Dashboard.
                </Typography>
                <form className="mt-8 mb-2" onSubmit={(e) => { e.preventDefault(); login(); }}>
                    <div className="flex flex-col gap-6 mb-1">
                        <Typography>Your Email</Typography>
                        <Input
                            size="lg"
                            placeholder="name@mail.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <Typography>Password</Typography>
                        <Input
                            type="password"
                            size="lg"
                            placeholder="********"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <Button className="w-full mt-6" type="submit">
                        Sign In
                    </Button>
                </form>
            </Card>
        </div>
    );
}

export default Login;